import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app.module.routing';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { AppComponent } from './app.component';
import { ServiceProviders } from './app.module.provider';
import { NotFoundModule } from './shared/modules/not-found/not-found.module';
import { UserModule } from './modules/user/user.module';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { LanguageModule } from './shared/modules/language/language.module';
import { SnackbarTemplateModule } from './shared/modules/snackbar-template/snackbar-template.module';
import { AuthModule } from '@auth0/auth0-angular';
import { APP_CONFIG } from '@shared/config/app.config';
import { LoaderModule } from './shared/modules/loader/loader.module';
import { ModalsModule } from './shared/modules/modals/modals.module';

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './../assets/i18n/', '.json?v='+APP_CONFIG.version);
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    MatSnackBarModule,
    NotFoundModule,
    AuthModule.forRoot({
      domain: APP_CONFIG.auth0.domain,
      clientId: APP_CONFIG.auth0.clientId,
      audience: APP_CONFIG.auth0.audience,
      redirectUri: APP_CONFIG.auth0.redirectUri,
      errorPath: APP_CONFIG.auth0.errorPath,
      httpInterceptor: {
        allowedList: APP_CONFIG.auth0.allowedList,
      },
    }),
    UserModule,
    HttpClientModule,
    TranslateModule.forRoot({
      defaultLanguage: 'es',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    LanguageModule.forRoot(),
    SnackbarTemplateModule,
    LoaderModule,
    ModalsModule,
  ],
  providers: [ServiceProviders],
  bootstrap: [AppComponent],
})
export class AppModule {}
